var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMotionPathMobile = function SvgMotionPathMobile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "motion_path_mobile_svg__path-mobile",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 1850",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "motion_path_mobile_svg__motion-path",
    d: "M-1,0C42.896-1.43,118.3481,2.15,200,40c40.5063,18.777,81,37.5482,111,79,28.29,39.0894,26.8365,70.1227,29,236,2.2843,175.1344,4.8673,214.5441-28,243-7.5987,6.5788-42.5025,18.4753-112,42-99.1081,33.5477-101.4848,32.83-110,40-35.21,29.6474-30.334,72.028-30,246,.3149,164.0326-3.7747,203.9747,30,233,8.7,7.4768,42.6021,18.7333,110,41,96.3865,31.8439,99.4676,30.1477,110,39,32.5929,27.3936,28.0885,64.6487,30,231,1.9407,168.8882,7.5235,212.286-28,245-19.7651,18.2019-42.4675,24.0824-71,59a234.2645,234.2645,0,0,0-41,76",
    style: {
      fill: "none"
    }
  }));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMotionPathMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/motion_path_mobile.9a67797f94c70f0998566c73709434b3.svg";